import React, { useContext } from "react";
import {
  Text,
  LegacyCard as Card,
  Collapsible,
  ColorPicker,
  Layout,
  InlineStack,
  TextField,
  BlockStack,
  Box,
} from "@shopify/polaris";

// import hoc
import { withErrorBoundary } from "lib/hoc";

// import constant
import constant from "lib/constant/constant";
import { baseHelper } from "lib/helpers";

// import context
import { PrivateContext } from "lib/context";
import { BrandingContext } from "app/setup/modules/operator/features/branding/context/context";

const ToastBackground = () => {
  const {
    color,
    errorMessage,
    handleChange,
    hex,
    // learnMore,
    resetDefault,
  } = useContext(BrandingContext);
  const { cms = () => {}, currentUser } = useContext(PrivateContext);
  const { updatedAt = "" } = currentUser || {};
  const { HEX, COLOR, TOAST_BACKGROUND_COLOR, DEFAULT_TOAST_COLOR } = constant;

  return (
    <Collapsible open>
      <Layout.AnnotatedSection
        title={cms("section.toastBackgroundColor.title")}
        description={cms("section.toastBackgroundColor.description")}
      >
        <Card
          title={[
            cms("section.toastBackgroundColor.title"),

            updatedAt && (
              <Text as="span" tone="subdued">
                <Text variant="bodySm" as="p">{`${baseHelper.lastUpdateDate(updatedAt)}`}</Text>
              </Text>
            ),
          ]}
        >
          <Card.Section>
            <BlockStack gap="2">{cms("section.toastBackgroundColor.subDescription")}</BlockStack>
            <br />
            <InlineStack align="space-between">
              <Box width="60%">
                <BlockStack>
                  <TextField
                    label={cms("section.toastBackgroundColor.label.hexCode")}
                    value={hex.toastBackgroundHex}
                    onChange={(value) => handleChange(TOAST_BACKGROUND_COLOR, value, HEX)}
                    labelAction={
                      hex.toastBackgroundHex !== DEFAULT_TOAST_COLOR && {
                        content: cms("label.reset"),
                        onClick: () => resetDefault(TOAST_BACKGROUND_COLOR, DEFAULT_TOAST_COLOR, HEX),
                      }
                    }
                    error={errorMessage && errorMessage.toastBackgroundColor}
                  />
                  <br />
                  <Text as="span" variant="bodySm">
                    <div
                      style={{
                        borderRadius: ".5rem",
                        width: "max-content",
                        height: "28px",
                        background: hex.toastBackgroundHex,
                        color: hex.toastTextHex,
                        textAlign: "center",
                        padding: "6px 12px",
                      }}
                    >
                      {cms("section.toastBackgroundColor.label.sampleHeader")}
                    </div>
                  </Text>
                </BlockStack>
              </Box>
              <ColorPicker
                onChange={(value) => handleChange(TOAST_BACKGROUND_COLOR, value, COLOR)}
                color={color.toastBackgroundColor}
              />
            </InlineStack>
          </Card.Section>
        </Card>
      </Layout.AnnotatedSection>
    </Collapsible>
  );
};

export default withErrorBoundary(ToastBackground);
